export default __webpack_public_path__ + "static/media/gallery-8.9a61ff01.jpg";